import { useState, useEffect, useCallback } from "react";

export type UseSuggestionChipProps = {
  isSuggested?: boolean;
  onAcceptSuggestion?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onRejectSuggestion?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

type UseSuggestionChipReturn = {
  showSuggestionChip: boolean;
  onAcceptSuggestion?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onRejectSuggestion?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

/**
 * A hook that manages the suggestion chip UI and logic
 */
export const useSuggestionChip = (
  suggestionProps?: UseSuggestionChipProps
): UseSuggestionChipReturn => {
  // This state keeps track of whether this field is focused
  const [showSuggestionChip, setShowSuggestionChip] = useState(false);

  const {
    isSuggested,
    onAcceptSuggestion: onAcceptSuggestionProp,
    onRejectSuggestion: onRejectSuggestionProp,
  } = suggestionProps ?? {};

  useEffect(() => {
    if (isSuggested) {
      setShowSuggestionChip(true);
    }
  }, [isSuggested]);

  const onAcceptSuggestion = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (onAcceptSuggestionProp) {
        onAcceptSuggestionProp(e);
      }
      setShowSuggestionChip(false);
    },
    [onAcceptSuggestionProp]
  );

  const onRejectSuggestion = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (onRejectSuggestionProp) {
        onRejectSuggestionProp(e);
      }
      setShowSuggestionChip(false);
    },
    [onRejectSuggestionProp]
  );

  return {
    showSuggestionChip,
    onAcceptSuggestion,
    onRejectSuggestion,
  };
};
